<script>
import useConfiguration from "@/use/Configuration";
import {useSecurityStore} from "@/stores/Security";
import {onMounted} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    setup() {
        const {backgroundColor} = useSharedData();
        const {loading, configurations, findAll, save} = useConfiguration();
        
        const securityStore = useSecurityStore();
        
        onMounted(() => findAll());
        
        return {
            backgroundColor,
            securityStore,
            loading,
            configurations,
            save,
        }
    }
};
</script>

<template>
    <w-app :title="$t('module.configuration')">
        <template #rightToolbar>
            <w-btn-apply
                :show="securityStore.authorities['UPDATE_PRIVILEGE_PARAM']"
                :loading="loading"
                @press="save"
            />
        </template>
        
        <template #content>
             <v-tabs
                            dense
                            height="35"
                            color="teal"
                            :background-color="backgroundColor"
                        >
                            <v-tab>Email</v-tab>
                            
                            
                            <v-tab-item>
                                <v-container fluid>
                                    <v-row dense>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.email_object') }}</strong>
                                            <w-text-field
                                                v-model="configurations[129].strr"
                                                not-clearable
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="6">
                                            <strong>{{ $t('common.email_body') }}</strong>
                                            <w-simple-text-area
                                                v-model="configurations[130].strr"
                                                not-clearable
                                            />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                        </v-tabs>
        </template>
    </w-app>
</template>